// extracted by mini-css-extract-plugin
export var progressBar = "_ij-0";
export var progressBarInner = "_ij-1";